<div class="d-flex flex-column p-2">
    <app-search-filter>
        <div class="row">
            <div class="col-4">
                <label for="symbol" class="form-label font-12">نماد:</label>
                <app-symbol-search [isMulti]="true" (selectSearchSymbol)="selected($event)"></app-symbol-search>
            </div>
            <div class=" col-2">
                <label for="fiscalYear" class="form-label font-12">سال مالی:</label>
                <input type="input" class="form-control" id="fiscalYear" name="fiscalYear" [(ngModel)]="fiscalYear"
                    mask="0000" [allowNegativeNumbers]="false">
            </div>
            <div class=" col-2">
                <label for="reportMonth" class="form-label font-12"> ماه گزارش:</label>
                <input type="input" class="form-control" id="reportMonth" [(ngModel)]="reportMonth" name="reportMonth"
                    mask="0000" [allowNegativeNumbers]="false">
            </div>
            <div class=" col-4 d-flex align-items-end justify-content-end">
                <button class="btn btn-primary btn-sm" (click)="searchTable()">جستجو</button>
            </div>
        </div>
    </app-search-filter>
    <hr class="my-4" />

    <!-- Table content -->

    <app-table [data]="sales" [KeyName]="KeyName" [columnName]="columnName" [isLoading]="isLoading"
        (clickOnRow)="openEditPage($event)" [totalRecords]="totalRecords" [pageSize]="pageSize" [(page)]="page"
        (changePageEvent)="changePage($event)" (changeSizeEvent)="changeSize($event)" (sortEvent)="handleSort($event)">
    </app-table>

</div>